import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonDirective, IconComponent } from '@bioreferencehealth/ui-kit';
import { AnalyticsClickDirective } from 'src/modules/analytics/directives/analytics-click.directive';
import { AnalyticsEventName } from 'src/modules/analytics/models/analytics-event-name.enum';

@Component({
  selector: 'app-logout-button',
  standalone: true,
  templateUrl: './logout-button.component.html',
  styleUrls: ['./logout-button.component.scss'],
  imports: [IconComponent, RouterLink, ButtonDirective, AnalyticsClickDirective],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogoutButtonComponent {
  public readonly AnalyticsEventName = AnalyticsEventName;
}
